/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */
'use client'
import { checkLiked, deleteLike, registerLike } from '@/lib/like'
import { handleUserBehaviorWithoutPrice } from '@/lib/user_behavior/client'
import { useEffect, useState } from 'react'

type LikeButtonProps = {
  service_id: string
  item_id: number
  liked: boolean
}

export const LikeRectangleButton: React.FC<LikeButtonProps> = ({
  service_id,
  item_id,
  liked,
}) => {
  const [isLiked, setIsLiked] = useState(liked)
  useEffect(() => {
    const IsLiked = async () => {
      try {
        const res = await checkLiked(service_id, item_id)
        setIsLiked(res)
      } catch (error) {
        console.error(error)
      }
    }
    IsLiked()
  }, [service_id, item_id, liked])
  return (
    <div
      className="favorite-button w-[60%] mx-auto rounded-md bg-[#fafafa] py-3 px-10 relative font-sm text-center items-center"
      style={{ border: '1px solid #dddddd' }}
    >
      {isLiked ? (
        <div
          onClick={async () => {
            await deleteLike(service_id, item_id)
            setIsLiked(false)
          }}
          className="flex justify-center items-center"
        >
          <img alt="いいね" src={'/heart.svg'} width={15} height={15} />
          <span className="ml-2 text-xs">追加済み</span>
        </div>
      ) : (
        <div
          onClick={async () => {
            await registerLike(service_id, item_id)
            await handleUserBehaviorWithoutPrice(item_id, 'favorite')
            setIsLiked(true)
          }}
          className="flex justify-center items-center"
        >
          <img
            src={'/heart-gray.svg'}
            alt="いいね！"
            width={15}
            height={15}
            onClick={async () => {
              await registerLike(service_id, item_id)
              await handleUserBehaviorWithoutPrice(item_id, 'favorite')
              setIsLiked(true)
            }}
          />
          <span className="ml-2 text-xs">お気に入りに追加する</span>
        </div>
      )}
    </div>
  )
}
